import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DepartamentoUsuario } from '@app/_models/departamento-usuario';
import { AlertService, ContactosService, MenuService, UsuariosService } from '@app/_services';
import { AgentesService } from '@app/_services/agentes.service';
import { DepartamentosEnteService } from '@app/_services/departamentosente.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';


@Component({
  selector: 'app-departamentos-ente-detalles',
  templateUrl: './departamentos-ente-detalles.component.html',
})
export class DepartamentosEnteDetallesComponent implements OnInit {
  //hhh
  form: FormGroup;
  codigo: number;
  isAddMode: boolean;
  loading = false;
  submitted = false;
  idOrg:string;
  idDep:number;
  public usuariosData: DepartamentoUsuario[] = [];
  public camposValoresIsFromDep:boolean[];
  public listaUsuariosDep:DepartamentoUsuario[]=[];

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    private departamentosEnteService: DepartamentosEnteService,
    private alertService: AlertService,
    private menuService: MenuService
  ) {  }

  ngOnInit(): void {
    this.menuService.titulo = this.translateService.instant('agentes.departamentos');
    
    this.idOrg =this.route.snapshot.params['idorg'];
    this.codigo = this.route.snapshot.params['idDep'];
    //this.idOrg = this.route.snapshot.params['id'];

    this.isAddMode = !this.codigo;

    this.form = this.formBuilder.group({
        codigo: this.route.snapshot.params['idDep'],
        idOrg: this.idOrg,
        nombre: new FormControl('', [Validators.required]),
        descripcion: new FormControl('', [Validators.required]),
        activo: new FormControl(true),
             
    });

    if (!this.isAddMode) {
      this.departamentosEnteService.GetDepById(this.codigo)
          .pipe()
          .subscribe((result) => {
            this.form = this.formBuilder.group({
              codigo: this.route.snapshot.params['idDep'],
              idOrg: this.route.snapshot.params['id'],
              nombre: new FormControl(result.data[0].nombre, [Validators.required]),
              descripcion: new FormControl(result.data[0].descripcion, [Validators.required]),
              activo :new FormControl(result.data[0].activo),
            });
          });
  }

  //Load users-from-deps
  this.departamentosEnteService.getUsersFromDep(this.codigo)
  .pipe()
  .subscribe((result) => {
    console.log('Llegan usuarios');
    console.log(result);
    this.usuariosData = result.data;
    console.log(this.usuariosData.length);
    console.log('COnversion:');
    console.log(this.usuariosData);
    console.log('Rellenando camposValoresIsFromDep con result.data '+result.data);
    result.data.forEach(element => {

      console.log('*** '+element.id);
      this.camposValoresIsFromDep[element.id]=element.isFromDep;
    });
  });

  this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      // TODO This as a workaround.
      this.menuService.titulo = this.translateService.instant('contactos.contactos');
  });
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;

    // reset alerts on submit
    this.alertService.clear();

    // stop here if form is invalid
    if (this.form.invalid) {
        return;
    }

    this.loading = true;
    if (this.isAddMode) { 
        this.crearDepartametno();//En componente a parte
    } else {
        this.updateDepartamento();
    }
  }

  private crearDepartametno() {
    console.log('Creando Departamento');
    this.departamentosEnteService.insertDepartamento(this.form.value,this.idOrg)
        .subscribe((result) => { 
            if(!result.error) {
              this.alertService.success(this.translateService.instant('botones.creadocorrectamente'), { keepAfterRouteChange: true });
              this.router.navigate(['../'], { relativeTo: this.route });
            } else {
              this.alertService.error(this.translateService.instant('contactos.errorcrear'));
              this.loading = false;
            }
        });
  }

  private updateDepartamento() {
    console.log('Actualizando Departamento');
    this.departamentosEnteService.updateDepartamento(this.form.value)
        .pipe(first())
        .subscribe((result) => {
            if(!result.error) {
              //update users asigned to departments
              console.log(' Numero de Usuarios = '+this.usuariosData.length);
              this.usuariosData.forEach(element => {
                if(element.isFromDep){
                  var usr = new DepartamentoUsuario();
                    usr.isFromDep=element.isFromDep;
                    usr.id=element.id;
                    usr.idUser = element.idUser;
                    this.listaUsuariosDep.push(usr);
                }
              });
              console.log('Numero de usuarios seleccionados: '+this.listaUsuariosDep.length);
              console.log('Actualizando Usuarios de departamento: '+this.codigo+' ...');
              this.departamentosEnteService.updateUsersFromDepartment(this.listaUsuariosDep,this.codigo).pipe(first())
              .subscribe((result) => {
                console.log('RESULTADO Actualizar usuarios= '+ result);
                this.alertService.success(this.translateService.instant('botones.editadocorrectamente'), { keepAfterRouteChange: true });
                this.router.navigate(['departamentos-ente/', {idorg:this.idOrg}]);
              });

            } else {
              console.log('Error al actualizar los usuarios: ');
              this.alertService.error(this.translateService.instant('contactos.erroreditar'));
              this.loading = false;
            }
        });
  }


  onChange(e) {
    console.log('Entramos');
    e.selectedRows.map(item => {
      console.log('selected');
      console.log(item);
      item.dataItem.isFromDep = true;
      return item;
    });

    e.deselectedRows.map(item => {
      console.log('deselected');
      console.log(item);
      item.dataItem.isFromDep = false;
      return item;
    })
  }

}
